<template>
  <div class="component-upload-image">
    <!--    :data="{ code }"-->
    <el-upload
      multiple
      :action="uploadImgUrl"
      list-type="picture-card"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      name="file"
      :on-remove="handleRemove"
      :show-file-list="true"
      :headers="headers"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :class="{ hide: this.fileList.length >= this.limit }"
      :accept="accept"
      :http-request="httpRequest"
      :disabled="disabled"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <!-- 上传提示 -->
    <div class="el-upload__tip" slot="tip" v-if="showTip">
      请上传
      <template v-if="fileSize">
        大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
      </template>
      <template v-if="WHtip">
        宽度 <b style="color: #f56c6c">{{ width }} px</b> , 高度
        <b style="color: #f56c6c">{{ height }} px</b>
      </template>
      <template v-if="fileType">
        格式为 <b style="color: #f56c6c">{{ fileType.join('/') }}</b>
      </template>
      的文件
    </div>

    <div class="reviewImage">
      <el-image
        v-if="dialogImageUrl"
        :src="dialogImageUrl"
        fit="contain"
        style="width: 60px; height: 60px"
        :preview-src-list="[dialogImageUrl]"
        ref="reviewImage"
      />
    </div>

    <!--    <el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>-->
    <!--      <img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import { getBase64, compressImage, base64ToFile } from '@/util/util'
  import axios from 'axios'
  export default {
    props: {
      value: [String, Object, Array],
      // 图片数量限制
      limit: {
        type: Number,
        default: 5
      },
      // 压缩质量 0-1
      quality: {
        type: Number,
        default: 0.9
      },
      // 大小限制(MB)
      fileSize: {
        type: Number,
        default: 5
      },
      // 文件类型, 例如['png', 'jpg', 'jpeg']
      fileType: {
        type: Array,
        default: () => ['png', 'jpg', 'jpeg']
      },
      imageList: {
        type: Array,
        default: () => []
      },
      // 是否显示提示
      isShowTip: {
        type: Boolean,
        default: true
      },
      width: {
        type: Number,
        default: 0
      },
      height: {
        type: Number,
        default: 0
      },
      code: {
        type: String,
        default: 'unknown'
      },
      WHtip: {
        type: Boolean,
        default: false
      },
      accept: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        number: 0,
        uploadList: [],
        dialogImageUrl: '',
        dialogVisible: false,
        hideUpload: false,
        baseUrl: '',
        uploadImgUrl: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        // uploadImgUrl: 'https://custom-pre.ayundi.cn' + env.ferryUrl + '/oss/uploadV2',
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        fileList: [],
        disabled: false
      }
    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            // 首先将值转为数组
            const list = Array.isArray(val) ? val : this.value.split(',')
            // 然后将数组转为对象数组
            this.fileList = list.map((item) => {
              if (typeof item === 'string') {
                if (item.indexOf(this.baseUrl) === -1) {
                  item = { name: this.baseUrl + item, url: this.baseUrl + item }
                } else {
                  item = { name: item, url: item }
                }
              }
              return item
            })
          } else {
            this.fileList = []
            return []
          }
        },
        deep: true,
        immediate: true
      }
      // imageList: {
      //   handler(newVal) {
      //     if (this.watchNum > 0) return
      //     this.fileList = newVal
      //   },
      //   deep: true
      // }
    },
    computed: {
      // 是否显示提示
      showTip() {
        console.log('this', this.imageList)
        return this.isShowTip && (this.fileType || this.fileSize)
      }
    },
    mounted() {
      this.fileList = this.imageList
    },
    methods: {
      getImgSize(imgFile) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(imgFile)
          reader.onload = function () {
            const image = new Image()
            image.src = reader.result
            image.onload = function () {
              resolve({
                width: this.width,
                height: this.height,
                src: this.src
              })
            }
          }
        })
      },
      reset() {
        this.fileList = []
      },
      // 删除图片
      handleRemove(file, fileList) {
        const findex = this.fileList.map((f) => f.name).indexOf(file.name)
        if (findex > -1) {
          this.fileList.splice(findex, 1)
          this.$emit('input', this.listToString(this.fileList))
        }
      },
      // 上传成功回调
      handleUploadSuccess(res) {
        console.log('上传成功', res)
        if (!res.data) {
          this.$message.error(res.msg || '上传文件失败，请重试')
          return
        }
        this.uploadList.push({ name: res.data.name, url: res.data.url })
        console.log('成功后的数据', this.uploadList.length, this.number)
        if (this.uploadList.length === this.number) {
          this.fileList = this.fileList.concat(this.uploadList)
          this.uploadList = []
          this.number = 0
          this.disabled = false
          this.$emit('input', this.listToString(this.fileList))
        }
      },
      // 上传前loading加载
      handleBeforeUpload(file) {
        // eslint-disable-next-line
        return new Promise(async (resolve, reject) => {
          if (file.name && file.name.length > 80) {
            this.$message.error('文件名称不能超过80字!')
            reject(new Error('文件名称不能超过80字！'))
            return
          }
          let isImg = false
          if (this.fileType.length) {
            let fileExtension = ''
            if (file.name.lastIndexOf('.') > -1) {
              fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1)
            }
            isImg = this.fileType.some((type) => {
              if (file.type.indexOf(type) > -1) return true
              if (fileExtension && fileExtension.indexOf(type) > -1) return true
              return false
            })
          } else {
            isImg = file.type.indexOf('image') > -1
          }
          if (!isImg) {
            this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}图片格式文件!`)
            reject(new Error(`文件格式不正确, 请上传${this.fileType.join('/')}图片格式文件!`))
            return
          }
          if (this.width) {
            const { width, height } = await this.getImgSize(file)
            if (width !== this.width || height !== this.height) {
              this.$message.warning({
                message: '尺寸不符，请修改尺寸后重新上传！'
              })
              reject(new Error('尺寸不符，请修改尺寸后重新上传！'))
              return
            }
          }
          const isLt = file.size / 1024 / 1024 < (this.fileSize || 5)
          if (!isLt) {
            this.$message.error(`上传图片大小不能超过 ${this.fileSize} MB!`)
            reject(new Error(`上传图片大小不能超过 ${this.fileSize} MB!`))
            return
          }
          const base64 = await getBase64(file)
          const compressBase64 = await compressImage(base64, this.quality)
          const compressFile = base64ToFile(compressBase64, file.name)
          this.number++
          this.disabled = true
          resolve(compressFile)
        })
      },
      // 文件个数超出
      handleExceed() {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`)
      },
      // 上传失败
      handleUploadError() {
        console.log('执行上传失败')
        this.number = 0
        this.disabled = false
        this.$message.error('上传图片失败，请重试')
      },
      // 预览
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        // this.dialogVisible = true
        this.$nextTick(() => {
          const reviewImage = this.$refs.reviewImage
          if (reviewImage) {
            reviewImage.clickHandler()
          }
        })
      },
      // 对象转成指定字符串分隔
      listToString(list, separator) {
        let strs = ''
        separator = separator || ','
        for (const i in list) {
          strs += list[i].url.replace(this.baseUrl, '') + separator
        }
        return strs !== '' ? strs.substr(0, strs.length - 1) : ''
      },

      // 自定义上传函数
      httpRequest(options) {
        const { file, onProgress, onSuccess, onError } = options

        // 创建正确的 FormData
        const formData = new FormData()
        formData.append('file', file) // 使用 options.file
        formData.append('code', this.code)

        // 发送请求，不要使用 qs.stringify
        axios
          .post(this.uploadImgUrl, formData, {
            headers: {
              ...this.headers
              // 不要手动设置 Content-Type，让浏览器自动处理
            },
            onUploadProgress: (progressEvent) => {
              // 处理上传进度
              onProgress({ percent: (progressEvent.loaded / progressEvent.total) * 100 })
            }
          })
          .then((response) => {
            // 检查业务状态码，处理 202 错误
            if (response.data.code === 0) {
              // 成功
              onSuccess(response.data)
            } else {
              // 业务错误，包括 202 状态码
              onError(new Error(response.data.msg || '上传失败'))
            }
          })
          .catch((error) => {
            // 网络错误
            onError(error)
          })
      }
    }
  }
</script>
<style scoped lang="scss">
  // .el-upload--picture-card 控制加号部分
  ::v-deep.hide .el-upload--picture-card {
    display: none;
  }
  // 去掉动画效果
  ::v-deep .el-list-enter-active,
  ::v-deep .el-list-leave-active {
    transition: all 0s;
  }

  ::v-deep .el-list-enter,
  .el-list-leave-active {
    opacity: 0;
    transform: translateY(0);
  }

  .reviewImage {
    position: fixed;
    left: -99999999px;
  }
</style>
